// extracted by mini-css-extract-plugin
export default {"layoutMain":"Layouts_layoutMain__0mDmx","contentArea":"Layouts_contentArea__SfR0i"};